<template>
  <div>
    <button
      :class="button_class"
      :name="button_name"
      :style="{ pointerEvents: pointerEvent }"
      :type="buttonType"
      @click="disable"
      class="btn"
      value="true"
    >
      <span v-show="!disabled" class="ch-NextButton_Text">{{ active_text }}</span>
      <span v-show="disabled">
        <i class="spinner-border spinner-border-sm"></i>
        <span class="ch-NextButton_WaitText">{{ inactive_text }}</span>
      </span>
    </button>
    <slot name="confirmation"></slot>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ButtonCheckoutMixin from "../mixins/ButtonCheckoutMixin";

export default {
  name: "ButtonCheckoutConfirm",
  mixins: [ButtonCheckoutMixin],
  props: {
    confirmation_needed: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    buttonType() {
      return this.confirmation_needed ? "button" : "submit";
    },
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
    }),
    disable() {
      if (this.confirmation_needed) {
        this.showModal("checkoutConfirmationModal");
      } else {
        this.disableButtons();
      }
    },
    disableButtons() {
      this.setPointerEvent("none");
      this.setButtonsDisabled(true);
    },
  },
};
</script>
